import {
  COMPLETION_NOT_STARTED,
  COMPLETION_STARTED,
  COMPLETION_COMPLETE,
} from "%/dynamic-component-editor/constants/completion-status-values";

// 3-way folder status from the SAME leaf counts the progress bar renders.
// GUARD: leafTotal===0 (active folder, no active leaves) → not_started, not 0/0-complete.
export function folderCompletionStatusFromProgress(progress) {
  const total = Number(progress?.leafNodesInTree) || 0;
  const completed = Number(progress?.completedLeafNodesInTree) || 0;
  if (total <= 0 || completed <= 0) {
    return COMPLETION_NOT_STARTED;
  }
  if (completed >= total) {
    return COMPLETION_COMPLETE;
  }
  return COMPLETION_STARTED;
}

function entityIsFolder(entity) {
  return Boolean(entity?.isFolder ?? entity?.getFieldData?.()?.isFolder);
}

// ONE source of completion truth for every consumer that picks a component by
// completion (Completion Status/Toggle + the V2 feed row selector) — the same
// leaf-count progress the bar uses, so they can never disagree. Leaf stories
// keep their DIRECT status; folders derive from the leaf counts.
export function resolveCompletionStatus({ entity, storyId, statusByStory, progressByFolder }) {
  if (entityIsFolder(entity)) {
    return folderCompletionStatusFromProgress(progressByFolder?.[storyId]);
  }
  return statusByStory?.[storyId]
    || entity?.completionStatus
    || COMPLETION_NOT_STARTED;
}
